<template>
    <EvaluationActionIndicator icon="sr-2 sr-v2-eye-slashed" bg-color="bg-orange-300" />
</template>

<script>
import EvaluationActionIndicator from './EvaluationActionIndicator'

export default {
    components: { EvaluationActionIndicator }
}
</script>